import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=71067410&scoped=true&"
import script from "./Appbar.vue?vue&type=script&lang=js&"
export * from "./Appbar.vue?vue&type=script&lang=js&"
import style0 from "./Appbar.vue?vue&type=style&index=0&id=71067410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71067410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VSpacer})
